import {Injectable} from '@angular/core'; 
import {CanActivate, Router} from '@angular/router'; 
import {AuthService} from './auth.service';  
import {Observable} from 'rxjs/Observable'; 
import 'rxjs/add/operator/take'; 
 
 
// c.f. https://www.safaribooksonline.com/library/view/angular-2-cookbook/9781785881923/ch06s09.html
@Injectable() 
export class AuthGuardService implements CanActivate { 
  constructor(private authService_:AuthService,  private router_:Router) {} 
 
  canActivate():Observable<boolean> { 
    return this.authService_.emitter.map(data => {  
      if (!data) {  // TODO: add data.token.t0 (jwt) expired
        this.router_.navigate(['login']); 
      } else { 
        return true; 
      } 
    }).take(1);
  } 

} 


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/security/route-guards.service.ts